import React from 'react';

import { flagStyles } from '../settings';

const SvgNF = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3864px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgNF;
